// extracted by mini-css-extract-plugin
module.exports = {"help-icon":"HelpIcon_help-icon__37ZUS"};